import { Outlet, useNavigate, useLocation } from "react-router-dom";
import {
    AppBar,
    Toolbar,
    Typography,
    Button,
    Box
} from "@mui/material";
import Swal from "sweetalert2";


export default function TeacherLayout() {
    const navigate = useNavigate();
    const location = useLocation();


    const handleLogout = () => {
        Swal.fire({
            title: "Are you sure?",
            text: "You will be logged out of your account",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
            confirmButtonText: "Yes, Logout",
            cancelButtonText: "Cancel",
        }).then((result) => {
            if (result.isConfirmed) {
                localStorage.removeItem("schoolId");
                localStorage.removeItem("schoolTemplate");
                navigate("/teacher-login");

                Swal.fire({
                    icon: "success",
                    title: "Logged out",
                    text: "You have been logged out successfully",
                    timer: 1500,
                    showConfirmButton: false,
                });
            }
        });
    };


    const isActive = (path) => location.pathname === path;

    const navButtonStyle = (path) => ({
        color: "inherit",
        size: "small",
        mx: 0.5,
        fontWeight: isActive(path) ? 700 : 400,
        backgroundColor: isActive(path) ? "rgba(255, 255, 255, 0.15)" : "transparent",
        borderBottom: isActive(path) ? "2px solid white" : "2px solid transparent",
        borderRadius: "4px 4px 0 0",
        "&:hover": {
            backgroundColor: "rgba(255, 255, 255, 0.2)",
        }
    });

    return (
        <>
            <AppBar position="sticky" color="primary" elevation={2}>
                <Toolbar sx={{ gap: 1 }}>
                    <Typography fontWeight={600}   sx={{
    flexGrow: 1,
    color: '#FFFFFF',
    display: { xs: 'none', sm: 'block' } 
  }}>
                         {JSON.parse(localStorage.getItem("schoolName") || '""')}
                    </Typography>

                    <Button
                        sx={navButtonStyle("/teacher/dashboard")}
                        onClick={() => navigate("/teacher/dashboard")}
                    >
                        Dashboard
                    </Button>

                    <Button
                        sx={navButtonStyle("/teacher/print")}
                        onClick={() => navigate("/teacher/print")}
                    >
                        Print
                    </Button>

                    <Button
                        color="inherit"
                        size="small"
                        sx={{
                            ml: 2,
                            opacity: 0.9,
                            "&:hover": { backgroundColor: "rgba(255, 0, 0, 0.2)" }
                        }}
                        onClick={handleLogout}
                    >
                        Logout
                    </Button>
                </Toolbar>
            </AppBar>

            <Box
                sx={{
                    minHeight: "calc(100vh - 64px)",
                    background: "#f4f7fb",
                    p: { xs: 1, sm: 2 }
                }}
            >
                <Outlet />
            </Box>
        </>
    );
}